import React from 'react'
import { Input } from 'reactstrap'
import {
  getBackendTarget,
  setBackendTarget,
  BACKEND_TARGETS,
} from '../../config/backendEnv'

const BackendSelector = () => {
  const value = getBackendTarget()

  return (
    <div className="d-flex align-items-center px-2" title="Backend da API (apenas perm_id 1)">
      <Input
        type="select"
        bsSize="sm"
        value={value}
        onChange={(e) => setBackendTarget(e.target.value)}
        style={{ maxWidth: 160, fontWeight: 600 }}
      >
        <option value={BACKEND_TARGETS.development}>API: desenvolvimento</option>
        <option value={BACKEND_TARGETS.production}>API: produção</option>
      </Input>
    </div>
  )
}

export default BackendSelector
